import React, { useState } from 'react';

const Services = () => {
  const [expandedCard, setExpandedCard] = useState(0);

  const cards = [
    {
      id: 0,
      title: "Residential Construction",
      description: "Building custom homes with innovative designs and sustainable materials.",
      image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 1,
      title: "Commercial Projects",
      description: "Office buildings and commercial spaces designed for business growth.",
      image: "https://images.unsplash.com/photo-1487956382158-bb926046304a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      title: "Renovation Services",
      description: "Transform your existing space with expert remodeling.",
      image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      title: "Sustainable Building",
      description: "Eco-friendly construction with energy-efficient solutions.",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    },
  ];

  const handleCardClick = (index) => {
    setExpandedCard(index);
  };

  return (
    <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Building Your Vision with Precision
          </h1>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto mb-8">
            With years of excellence in construction, we deliver projects that stand the test of time.
          </p>
          <button className="bg-yellow-700 hover:bg-yellow-800 text-white px-8 py-3 rounded-lg font-medium text-lg transition duration-300 transform hover:-translate-y-1">
            Start Your Project Today
          </button>
        </div>

        {/* Single Row of Cards */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {cards.map((card, index) => (
            <div
              key={card.id}
              onClick={() => handleCardClick(index)}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index
                  ? 'md:col-span-2 shadow-2xl'
                  : 'md:col-span-1 shadow-lg hover:shadow-xl'
              }`}
            >
              <div className="h-64 md:h-80 relative">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover"
                />
                <div className={`absolute inset-0 transition-all duration-500 ${
                  expandedCard === index 
                    ? 'bg-gradient-to-t from-black/80 via-black/50 to-transparent' 
                    : 'bg-gradient-to-t from-black/70 via-black/40 to-transparent'
                }`} />
                
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className={`font-bold transition-all duration-300 ${
                      expandedCard === index ? 'text-2xl' : 'text-xl'
                    }`}>
                      {card.title}
                    </h3>
                  </div>
                  
                  {/* Description - Only shows when expanded */}
                  <div className={`transition-all duration-500 overflow-hidden ${
                    expandedCard === index 
                      ? 'max-h-40 opacity-100 mt-2' 
                      : 'max-h-0 opacity-0'
                  }`}>
                    <p className="mb-2">
                      {card.description}
                    </p>
                  </div>
                  
                  {/* {expandedCard === index && (
                    <button className="mt-4 bg-white text-yellow-700 hover:bg-yellow-50 px-4 py-2 rounded-lg font-medium transition duration-300 transform hover:scale-105">
                      Learn More
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;  